import { centsToFixed2 } from '../utils';

// Define types for better type safety
type TrackingEvent = {
  event: string;
  ecommerce: {
    currency?: string;
    value?: number;
    items?: Array<{
      item_id?: string;
      item_name?: string;
      index?: number;
      price?: number;
      quantity?: number;
    }>;
  };
};

// Modified to make ecommerce clearing push work
interface DataLayerEvent {
  event?: string;
  ecommerce?: {
    [key: string]: any;
  } | null;
}

declare global {
  interface Window {
    dataLayer: DataLayerEvent[];
  }
}

// Main tracking function
export const trackEvent = (eventName: string, data: any) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  // Clear previous ecommerce object as per GA4 requirements
  window.dataLayer.push({ ecommerce: null });

  const event: TrackingEvent = {
    event: eventName,
    ecommerce: {
      ...data,
    },
  };

  window.dataLayer.push(event);
};

export const dataLayerEventPurchase = (bookingId: string, actionPayload: any, currency: string) => {
  trackEvent('purchase', {
    transaction_id: bookingId,
    currency: currency,
    value: centsToFixed2(actionPayload?.cart?.discountedPriceWithoutDeposit.gross),
    tax: centsToFixed2(actionPayload?.cart?.discountedPriceWithoutDeposit.vat),
    items: actionPayload?.cart?.items?.map((item: any) => ({
      item_id: item.itemId,
      item_name: item.name,
      price: centsToFixed2(item.discountedPrice?.gross),
      quantity: item.qty,
    })),
  });
};

export const dataLayerEventAddToCart = (params: any, currency: string) => {
  trackEvent('add_to_cart', {
    currency: currency,
    value: params.price?.net ? +centsToFixed2(params.price.net) : undefined,
    items: [
      {
        item_id: params.itemId,
        item_name: params.name,
        index: 0,
      },
    ],
  });
};

export const dataLayerEventInitiateCheckout = (state: any) => {
  trackEvent('begin_checkout', {
    currency: state.currency,
    value: +centsToFixed2(state.amountToPay.total),
  });
};

export const dataLayerEventAddShippingInfo = (state: any) => {
  trackEvent('add_shipping_info', {
    currency: state.currency,
    value: +centsToFixed2(state.amountToPay.total),
  });
};
